import { isPostalRequired } from '../../../utils/localisation_countries.utils';

export const isPostalCodeValid = (country: string, code: string) => {
  return (
    (isPostalRequired(country) && code?.trim() !== '') ||
    !isPostalRequired(country)
  );
};
